import { RouteType } from "../../../types/RouteType";

const productManagementRoute: RouteType = {
    name: "Product Management",
    path: "/product/management/:productId?",
    defaultParams: {
        productId: null,
    },
    layout: "/app",
    viewportCard: {
        header: {
            component: () => import("./ProductManagement.Header"),
            title: "Product Management",
            color: "primary",
            enableRefreshButton: true,
            enableBackButton: true,
        },
        body: {
            component: () => import("./ProductManagement.Container"),
            grayBackground: false,
        },
    },
    group: 'Product',
  requiresAuth: true,
    requiresPermission: false,
    beforeEnter: async ({ rootStore, params }) => {
        try {
            const productManagementStore = rootStore.productManagementStore;
            if (productManagementStore && typeof productManagementStore === 'object' && 'loadProducts' in productManagementStore) {
                await (productManagementStore as any).loadProducts(params.productId);
            }
            return true;
        } catch (error) {
            console.error("Failed to load products:", error);
            return false;
        }
    },
    onParamsChange: async ({ rootStore, params, previousParams }) => {
        if (params.productId !== previousParams?.productId) {
            const productManagementStore = rootStore.productManagementStore;
            if (productManagementStore && typeof productManagementStore === 'object' && 'loadProducts' in productManagementStore) {
                await (productManagementStore as any).loadProducts(params.productId);
            }
        }
    },
    dialogs: [],
};

export default productManagementRoute;
